import React, { useMemo, useState, useEffect, memo } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { IconButton, Tooltip } from '@material-ui/core';
import { DataGrid, esES } from '@mui/x-data-grid';
import { Dialpad } from '@material-ui/icons';
// WService
import { wsFindBy, wsPost } from 'services/WService';
import moment from 'moment';

const columns = [
  {
    field: 'num',
    width: 10,
    align: 'right',
    headerName: '#',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  {
    field: 'CardName',
    width: 250,
    headerName: 'Cliente / Proveedor',
    hideable: false,
    sortable: false,
  },
  {
    field: 'TipoPago',
    width: 150,
    headerName: 'Tipo Pago',
    hideable: false,
    sortable: false,
  },
  {
    field: 'TipoComprobante', 
    width: 120,
    headerName: 'Tipo Comprob.',
    hideable: false,
    sortable: false,
  },
  {
    field: 'Serie',
    width: 120,
    headerName: 'Serie',
    hideable: false,
    sortable: false,
  },
  {
    field: 'Correlativo',
    width: 120,
    headerName: 'Correlativo',
    hideable: false,
    sortable: false,
  },
  {
    field: 'Zona',
    width: 80,
    headerName: 'Zona',
    hideable: false,
    sortable: false,
  },
  { 
    field: 'FechaContable', 
    width: 100, 
    headerName: 'Fec. Contable', 
    hideable: false, 
    sortable: false 
  },
  {
    field: 'TotalPagar',
    width: 120,
    align: 'right',
    headerName: 'Total a Pagar',
    hideable: false,
    sortable: false,
    type: 'number',
  },
  {
    field: 'Comentario',
    width: 350,
    headerName: 'Comentario',
    hideable: false,
    sortable: false,
  },
];


function PaymentDocumentsImport(props) {
  const { setDocuments } = props;
  const { showNotify } = props;
  const { importedData = [], isImportMode = false } = props;
  
  const [loading, setLoading] = useState(false);
  const [aviableDocuments, setAviableDocuments] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);

  const dataGridColumns = useMemo(() => [...columns], []);

  const aviableDocumentsMapped = useMemo(() => {
    return aviableDocuments.map((item, i) => {

      return {
        id: item.CardCode + '-' + i,
        num: i + 1,
        base_business_partner_id: item.base_business_partner_id,
        CardCode: item.CardCode,
        CardName: item.CardName || '',
        CardType: item.CardType || '',
        TipoPago: item.TipoPago || '',
        TipoComprobante: item.TipoComprobante || null, 
        Serie: item.Serie || null,
        Correlativo: item.Correlativo || null,
        Zona: item.Zona || '',
        FechaContable: item.FechaContable || '',
        TotalPagar: parseFloat(item.TotalPagar || 0).toFixed(2),
        Comentario: item.Comentario || '',
        originalData: item
      };
    });
  }, [aviableDocuments]);

  // Mapear los datos del Excel a la estructura esperada
  useEffect(() => {
    if (!isImportMode || !importedData?.length) return;
    
    setLoading(true);
    
    const mappedData = importedData.map(item => ({
      base_business_partner_id: item.base_business_partner_id,
      CardCode: item.CardCode,
      CardName: item.CardName,
      CardType: item.CardType,
      TipoPago: item.TipoPago,
      TipoComprobante: item.TipoComprobante, 
      Serie: item.Serie,
      Correlativo: item.Correlativo,
      Zona: item.base_zone_description,
      TotalPagar: item.TotalPagar,
      FechaContable: item.FechaContable,
      Comentario: item.Comentario,
      // Mantener datos originales
      originalItem: item
    }));

    setAviableDocuments(mappedData);
    setLoading(false);
  }, [importedData, isImportMode]);

  // Función para manejar cambios de selección
  const handleSelectionChange = (model) => {
    const selectedIDs = new Set(model);
    const selectedRowData = aviableDocumentsMapped.filter((row) =>
      selectedIDs.has(row.id)
    );
    
    setSelectionModel(selectedRowData);
  };

  // Actualizar setDocuments cuando cambie la selección
  useEffect(() => {
    const formattedDocuments = selectionModel.map((row) => ({
      base_business_partner_id: row.base_business_partner_id,
      CardCode: row.CardCode,
      CardName: row.CardName,
      CardType: row.CardType,
      TipoPago: row.TipoPago,
      TipoComprobante: row.TipoComprobante,
      Serie: row.Serie,
      Correlativo: row.Correlativo,
      Zona: row.Zona,
      TotalPagar: row.TotalPagar,
      FechaContable: row.FechaContable,
      Comentario: row.Comentario,
      // Datos adicionales que puedas necesitar para el procesamiento
      base_zone_id: row.originalData?.originalItem?.base_zone_id,
      base_zone_description: row.originalData?.originalItem?.base_zone_description,
    }));
    
    setDocuments(formattedDocuments);
    console.log("Documentos seleccionados:", formattedDocuments);
  }, [selectionModel, setDocuments]);

  const totalCargado = useMemo(() => {
    return aviableDocumentsMapped.reduce((acc, doc) => acc + parseFloat(doc.TotalPagar || 0), 0).toFixed(2);
  }, [aviableDocumentsMapped]);
  
  return (
    <CardContainer 
      icon={null} 
      title={`Documentos importados desde Excel: \nTotal a Pagar: S/ ${totalCargado || 0.00}`}
      style={{ height: '600px' }}
    >
      <DataGrid
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        checkboxSelection
        rowHeight={35}
        columns={dataGridColumns}
        onSelectionModelChange={handleSelectionChange}
        loading={loading}
        rows={aviableDocumentsMapped}
        getRowId={(row) => row.id}
      />
    </CardContainer>
  );
}

export default memo(PaymentDocumentsImport);
